export enum EPermissionAction {
	Edit = 'edit',
	Delete = 'delete',
}

export enum EUserManagementPermissionsPageGetParams {
	Action = 'action',
}

export enum EUserManagementPermissionsPageGetParamsActionTypes {
	Create = 'create',
}

export enum EPermissionsTableColumnKey {
	GUID = 'guid',
  DefaultGroupName = 'default_group_name',
  DefaultName = 'default_name',
  KetoPermissionName = 'keto_permission_name',
  KetoScopeName = 'keto_scope_name',
  KetoKind = 'keto_kind',
  Status = 'status',
	Menu = 'menu',
}

export enum EModalType {
	Create = 'create',
	Edit = 'edit',
}

export enum EPermissionsCreateEditForm {
  GUID = 'guid',
  GroupName = 'default_group_name',
  Name = 'default_name',
  KetoPermissionName = 'keto_permission_name',
  KetoScopeName = 'keto_scope_name',
  KetoKind = 'keto_kind',
  GroupLangKey = 'group_lang_key',
  GroupSortNumber = 'group_sort_number',
  NameLangKey = 'name_lang_key',
  NameSortNumber = 'name_sort_number',
}

export enum EPermissionsFilterFormKeys {
  GUID = 'guids',
  Type = 'keto_permission_names',
  Scope = 'keto_scope_names',
  Kind = 'keto_kinds',
  Ordering = 'ordering',
}

export enum EPermissionsFilterKeys {
  GUID = 'guids',
  Type = 'keto_permission_names',
  Scope = 'keto_scope_names',
  Kind = 'keto_kinds',
  Ordering = 'ordering',
}
